// extracted by mini-css-extract-plugin
export var standaloneTable = "_gh-0";
export var standaloneTableWithBodyFill = "_gh-1";
export var withExtraHeader = "_gh-2";